import { render, staticRenderFns } from "./TemplateRowPest.vue?vue&type=template&id=5961648e&"
import script from "./TemplateRowPest.vue?vue&type=script&lang=js&"
export * from "./TemplateRowPest.vue?vue&type=script&lang=js&"
import style0 from "./TemplateRowPest.vue?vue&type=style&index=0&id=5961648e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports